<template id="">
  <div class="row">
    <b-table-simple>
      <b-tr v-for="setting of displaySettings" :key="setting.key">
        <b-td>
          <h3 v-label-key="setting.value">{{ setting.value }}</h3>
          <p v-if="setting.stores && setting.stores.length">
            <span v-label-key="'STORE_SETTINGS'">Store settings</span>:
            <ul>
              <li v-for="store of setting.stores" :key="store.id">
                <router-link :to="{name: 'store-detail', params: store}">
                  {{ store.name }}:
                </router-link>
                <code class="store-settings-value">{{ store[setting.key] }}</code>
              </li>
            </ul>
          </p>
        </b-td>
        <b-td class="text-right">
          <template v-if="setting.key !== 'enable_fourseasons'">
            <b-button variant="success" @click="setValue(setting.key)">
              <span v-label-key="'SET_SETTING_CHILD_STORES'">Set for All Child Stores</span>
            </b-button>
          </template>
          <template v-else>
            <b-button variant="success" @click="pushSetting(setting.key, true)">
              <span v-label-key="'ENABLE_SETTING_CHILD_STORES'">Enable for All Child Stores</span>
            </b-button>
            <b-button class="ml-2" variant="danger" @click="pushSetting(setting.key, false)">
              <span v-label-key="'DISABLE_SETTING_CHILD_STORES'">Disable for All Child Stores</span>
            </b-button>
          </template>
        </b-td>
      </b-tr>
    </b-table-simple>
  </div>
</template>
<script>
import $api from '@/services/api';
import { mapGetters } from 'vuex';

const settings = {
  // Retail app contact support options
  support_name: 'STORE_SETTING_SET_SUPPORT_NAME',
  support_email: 'STORE_SETTING_SET_SUPPORT_EMAIL',
  support_phone: 'STORE_SETTING_SET_SUPPORT_PHONE',

  // Chain group
  chain_group: 'STORE_SETTING_SET_CHAIN_GROUP',

  // Has FS printer
  enable_fourseasons: 'STORE_SETTING_ENABLE_HAS_FOUR_SEASONS_PRINTER',
};

const promptLabels = {
  distributor: 'SET_DISTRIBUTOR_STORE_SETTING',
  subdistributor: 'SET_SUBDISTRIBUTOR_STORE_SETTING',
  chain: 'SET_CHAIN_STORE_SETTING',
};
const confirmLabels = {
  distributor: 'CONFIRM_DISTRIBUTOR_STORE_SETTING',
  subdistributor: 'CONFIRM_SUBDISTRIBUTOR_STORE_SETTING',
  chain: 'CONFIRM_CHAIN_STORE_SETTING',
};
const alertLabels = {
  distributor: 'ALERT_DISTRIBUTOR_STORE_SETTING',
  subdistributor: 'ALERT_SUBDISTRIBUTOR_STORE_SETTING',
  chain: 'ALERT_CHAIN_STORE_SETTING',
};

export default {
  computed: {
    displaySettings() {
      return Object.keys(settings).map((key) => ({
        key,
        value: settings[key],
        stores: this.$store.state.global.stores && this.$store.state.global.stores.filter((store) => (store[key])),
      }));
    },
    level() {
      if (this.$route.path.includes('chain')) return 'chain';
      if (this.$route.path.includes('subdi')) return 'subdistributor';
      return 'distributor';
    },
    ...mapGetters('translations', {
      replaceLabel: 'getReplaceLabel',
      getLabel: 'getLabel',
    }),
  },
  methods: {
    async setValue(key) {
      const settingsLabel = this.getLabel(settings[key]);

      const promptLabelKey = promptLabels[this.level];
      const promptLabel = this.replaceLabel(promptLabelKey, { '{SETTINGS_LABEL}': settingsLabel });

      // eslint-disable-next-line no-restricted-globals, no-alert
      const value = prompt(promptLabel);
      if (value === null) return;
      await this.pushSetting(key, value);
    },
    async pushSetting(key, newValue) {
      const settingsLabel = this.getLabel(settings[key]);

      const confirmLabelKey = confirmLabels[this.level];
      const confirmLabel = this.replaceLabel(confirmLabelKey, { '{SETTINGS_LABEL}': settingsLabel, '{SETTINGS_VALUE}': newValue });

      // eslint-disable-next-line no-restricted-globals, no-alert
      const confirmSetting = confirm(confirmLabel);
      if (!confirmSetting) return;
      try {
        await $api.put(`/v1/dashboard/${this.level}s/${this.$route.params.id}/storesettings/${key}`, {
          value: newValue,
        });
        // Reload the stores
        const bodyContent = {};
        bodyContent[`${this.level}_id`] = this.$route.params.id;
        this.$store.dispatch('global/getStores', bodyContent);

        const alertLabelKey = alertLabels[this.level];
        const alertLabel = this.replaceLabel(alertLabelKey, { '{SETTINGS_LABEL}': settingsLabel, '{SETTINGS_VALUE}': newValue });
        // eslint-disable-next-line no-restricted-globals, no-alert
        alert(alertLabel);
      } catch (err) {
        // eslint-disable-next-line no-restricted-globals, no-alert
        alert(this.getLabel('ERROR_SAVING_CONTACT_SUPPORT'));
      }
    },
  },
};
</script>
<style scoped>
.store-settings-value {
  background-color: #EEE;
  border-radius: 2px;
  padding: 2px;
}
</style>
